module.exports = __webpack_public_path__ + "img/信息编辑.65fa8c12.png";